import { ETableStructureAlign, ETableStructureType, TTableStructure } from 'ui/EasTable/types';
import { TCountryVatRate } from 'redux/reducers/taxDuties/types';
import { ERateType, ESource } from '../../../../redux/reducers/taxDuties/constants';

export const tableStructure: TTableStructure<keyof TCountryVatRate>[] = [
	{
		name: 'ID',
		selector: 'id',
		show: false,
		sortable: true,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.NUMBER,
		align: ETableStructureAlign.LEFT,
		key: true,
	},
	{
		// Sent as a `countryId` entry of `filters`, the options come from the country reference list.
		name: 'Country',
		selector: 'country',
		show: true,
		sortable: true,
		filterable: true,
		// separateFilter: true,
		// separateFilterAutocomplete: true,
		colSpan: 1,
		type: ETableStructureType.COUNTRY_EU,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'Rate',
		selector: 'rate',
		show: true,
		sortable: true,
		// filterable: true,
		separateFilter: true,
		colSpan: 1,
		type: ETableStructureType.AMOUNT,
		align: ETableStructureAlign.RIGHT,
		currency: () => '%',
	},
	{
		name: 'Rate Type',
		selector: 'rateType',
		show: true,
		sortable: true,
		filterable: true,
		colSpan: 1,
		type: ETableStructureType.STATUS,
		align: ETableStructureAlign.LEFT,
		filter: [
			[ERateType.STANDARD, 'Standard Rate'],
			[ERateType.REDUCED, 'Reduced Rate'],
		],
	},
	{
		name: 'Description',
		selector: 'description',
		show: false,
		sortable: false,
		filterable: false,
		searchable: true,
		colSpan: 2,
		type: ETableStructureType.STATUS,
		align: ETableStructureAlign.LEFT,
	},

	{
		name: 'Source',
		selector: 'source',
		show: true,
		sortable: true,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.STATUS,
		align: ETableStructureAlign.LEFT,
		filter: [
			[ESource.MANUAL, 'Manual'],
			[ESource.UPLOAD, 'Upload'],
		],
	},

	{
		name: 'HS6P Code',
		selector: 'hs6pCode',
		show: true,
		sortable: true,
		filterable: false,
		searchable: true,
		colSpan: 1,
		type: ETableStructureType.STRING,
		align: ETableStructureAlign.LEFT,
	},

	{
		name: 'Category',
		selector: 'category',
		show: true,
		sortable: true,
		filterable: false,
		searchable: true,
		colSpan: 1,
		type: ETableStructureType.TEXT,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'Comments',
		selector: 'comments',
		show: true,
		sortable: false,
		filterable: false,
		searchable: true,
		colSpan: 2,
		type: ETableStructureType.TEXT,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'Updated',
		selector: 'timestamp',
		show: true,
		sortable: true,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.DATE_TIME,
		align: ETableStructureAlign.CENTER,
	},
];
